import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowTriangleTop"><Path d="M17.252 19.25H6.74803C5.26465 19.25 4.29985 17.6884 4.96324 16.3611L10.2152 5.85345C10.9506 4.38218 13.0494 4.38218 13.7848 5.85345L19.0368 16.3611C19.7001 17.6884 18.7354 19.25 17.252 19.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowTriangleTop;
